export enum FeatureFlag {
    EmbeddedLoginAllOrgs = 'EMBEDDED_LOGIN_ALL_ORGS',
    MerchantKyc = 'MERCHANT_KYC',
}

export enum OrganizationFeatureFlag {
    EmbeddedLogin = 'EMBEDDED_LOGIN',
}
